import { OvertimeDefaultCell } from "app/components/React/SocialOvertime/SocialOvertimeCell";
import {
    GroupedCellSite,
    TrafficShare,
    ChangePercentage,
    GroupTrafficShare,
    IndexCell,
} from "app/components/React/Table/cells";
import {
    DefaultCellHeader,
    DefaultCellHeaderRightAlign,
    HeaderCellBlank,
} from "app/components/React/Table/headerCells";
import { i18nFilter } from "app/filters/i18nFilter";

export const getSocialOverviewColumns = ({ compare, sortedColumn, sortDirection, durationTooltipParams }) => {
    const i18n = i18nFilter();
    const commonColumns = [
        {
            fixed: true,
            cellComponent: OvertimeDefaultCell,
            sortable: false,
            headerComponent: HeaderCellBlank,
            isResizable: false,
            width: 48,
            columnClass: "collapseControlColumn",
            cellClass: "collapseControlCell",
        },
        {
            width: 65,
            cellComponent: IndexCell,
            sortable: false,
            fixed: true,
        },
        {
            field: "Page",
            displayName: i18n("analysis.source.social.table.columns.pages.title"),
            tooltip: i18n("analysis.source.social.table.columns.pages.title.tooltip"),
            cellComponent: GroupedCellSite,
            sortable: true,
            showTotalCount: true,
            minWidth: 220,
        },
    ];
    const singleColumns = [
        {
            field: "Share",
            displayName: i18n("analysis.source.social.table.columns.share.title"),
            tooltip: i18n("analysis.source.social.table.columns.share.title.tooltip"),
            cellComponent: TrafficShare,
            sortable: true,
            minWidth: 150,
        },
        {
            field: "Change",
            displayName: i18n("analysis.source.social.table.columns.change.title"),
            tooltip: i18n("analysis.source.social.table.columns.change.title.tooltip", durationTooltipParams),
            cellComponent: ChangePercentage,
            headerComponent: DefaultCellHeaderRightAlign,
            sortable: true,
            width: 110,
        },
    ];

    const compareColumns = [
        {
            field: "TotalShare",
            displayName: i18n("analysis.source.search.all.table.columns.totalShareCompare.title"),
            tooltip: i18n("analysis.source.search.all.table.columns.totalShareCompare.fix.title.tooltip"),
            cellComponent: TrafficShare,
            sortable: true,
            isSorted: true,
            minWidth: 150,
        },
        {
            field: "SiteOrigins",
            displayName: i18n("analysis.source.search.all.table.columns.shareCompare.title"),
            cellComponent: GroupTrafficShare,
            minWidth: 250,
        },
    ];

    return [...commonColumns, ...(compare ? compareColumns : singleColumns)].map<any>((col: any) => {
        const isSorted = sortedColumn && col.field === sortedColumn;
        return {
            ...col,
            visible: true,
            sortable: col.sortable || false,
            headerComponent: col.headerComponent || DefaultCellHeader,
            isSorted,
            sortDirection: isSorted ? sortDirection : "desc",
            isResizable: col.isResizable !== false,
        };
    });
};
